import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const TransactionSearchReportFormRoot = styled(Box)(() => ({
  margin: "20px 0",
}));
